// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");
require("component-leaflet-map");


var zoom = document.getElementById("interactive").offsetWidth > 500 ? 11 : 10;



const dataJSON = require("./SeattleMayorTotal.geo.json");
// var contents = fs.readFile("./data.csv");
// console.log(contents);

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);
var focused = false;

const colorBlocks = document.querySelectorAll('.color');
var allSpans = document.querySelector('#legendCon').getElementsByTagName('span');

// const dataJSON = require("./JustWACounties.geo.json");
// const dataCSV = "./data.csv";

// const fileContent = fs.readFileSync("./data.csv");
dataJSON.features.forEach(function(f) {
  ["BruceHar_7"].forEach(function(prop) {
     var numTwo = (f.properties[prop] / f.properties["TotalVotes_TotalVotes"]) * 100;
     f.properties["HarrellVotes"] = numTwo.toFixed(1);
  });
  ["M.Lorena_7"].forEach(function(prop) {
    var num = (f.properties[prop] / f.properties["TotalVotes_TotalVotes"]) * 100;
    f.properties["GonzaVotes"] = num.toFixed(1);
  });
});


var arrayLegend = {
  HarrellVotes_array: [10,20,30,40,50],
  GonzaVotes_array: [10,20,30,40,50],
  his_pop: "HarrellVotes",
  his_vaxx: "GonzaVotes"
};

var getColor = function(d, array) {
  var value = d;
  // console.log(value);
  var thisArray = arrayLegend[array];
  let chosenColorArray = orangeArray;

  for (let h = 0; h < colorBlocks.length; h++) {
    colorBlocks[h].style.backgroundColor = chosenColorArray[h];
  }


  if (typeof value == "string") {
    value = Number(value.replace(/,/, ""));
  }
  if (typeof value != "undefined") {
    return value >= thisArray[5] ? chosenColorArray[6] :
           value >= thisArray[4] ? chosenColorArray[5] :
           value >= thisArray[3] ? chosenColorArray[4] :
           value >= thisArray[2] ? chosenColorArray[3] :
           value >= thisArray[1] ? chosenColorArray[2] :
           value >= thisArray[0]  ? chosenColorArray[1] :
           chosenColorArray[0] ;
  } else {
    return "gray"
  }
};

var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");

orangeArray = ['#FAE2C1', '#F4BD6E', '#ED8A52', '#E34D32', '#B22118', "#500601"];

function restyleLayer(propertyName) {

  geojson.eachLayer(function(featureInstanceLayer) {
      var propertyValue = featureInstanceLayer.feature.properties[propertyName];
      var colorArray = propertyName + "_array";

      // Your function that determines a fill color for a particular
      // property name and value.
      var myFillColor = getColor(propertyValue, colorArray);

      featureInstanceLayer.setStyle({
          fillColor: myFillColor,
          opacity: .25,
          color: '#000',
          fillOpacity: 0.8,
          weight: 1
      });
  });
}




var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
  layer.on({
    mouseover: function(e) {
      layer.setStyle({ weight: 2, fillOpacity: 1 });
    },
    mouseout: function(e) {
      if (focused && focused == layer) { return }
      layer.setStyle({ weight: 1, fillOpacity: 0.7 });
    }
  });
};


var geojson = L.geoJson(dataJSON, {
  onEachFeature: onEachFeature
}).addTo(map);



var filterMarkers = function(clickedID) {
  document.querySelectorAll("#legendCon span").forEach(el => el.classList.add('hide'));
  document.querySelectorAll(`#legendCon .${clickedID}`).forEach(el => el.classList.remove("hide"));
  document.querySelectorAll(".buttonCon .button").forEach(el => el.classList.remove("active"));
  document.getElementById(clickedID).classList.add("active");
  restyleLayer(arrayLegend[clickedID]);
}

document.querySelectorAll(".buttonCon .button").forEach(el => el.addEventListener('click', () => {
  filterMarkers(el.id);
}));


map.setView(new L.LatLng(47.61983200877938, -122.33179693477256), zoom);


//kick things off//
filterMarkers("his_pop");
